import React from 'react'

import { AdminContext } from 'contexts/AdminContext'
import { Table, Form, Button } from '_zari/core'

import * as Modals from './modals'

import { ProyectoSelect } from 'sharedComponents/select'

const FilaDetalleTemplate = ({
  index,
  row,
  actualizarFilaHandler,
  actualizarComentarioHandler,
  eliminarFilaHandler,
  abrirModalDetalle
}) => {
  const __adminContext = React.useContext(AdminContext)

  const esDeRequerimiento = !!row._fromRequerimiento
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [precio, setPrecio] = React.useState(row.precio)
  const [_idProyecto, setIdProyecto] = React.useState(row._idProyecto || '')

  // Sincronizar input local cuando el reducer clampea la cantidad
  React.useEffect(() => {
    if (String(row.cantidad ?? '') !== String(cantidad ?? '')) {
      setCantidad(row.cantidad)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row.cantidad])

  const [mostrarModalHistorialCompras, setMostrarModalHistorialCompras] = React.useState(false)
  const [mostrarActualizarComentarioModal, setMostrarActualizarComentarioModal] = React.useState(false)
  const [mostrarActualizarPresupuestoModal, setMostrarActualizarPresupuestoModal] = React.useState(false)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      __focusPrecio = true
      saltarCampo = true
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idProyecto,
      __updatedField: 'cantidad',
      __focusCantidad,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpPrecioHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = true
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarFila = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idProyecto,
      __updatedField: 'precio',
      __focusCantidad,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickActualizarComentarioHandler = () => {
    window.setTimeout(() => {
      setMostrarActualizarComentarioModal(true)
    }, 150)
  }

  const actualizarComentarioInnerHandler = ({ comentario }) => {
    setMostrarActualizarComentarioModal(false)
    actualizarComentarioHandler({
      ...row,
      comentario
    })
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const blurProyecto = () => {
    let __focusCantidad = false
    let __focusPrecio = false
    let saltarFila = false
    let saltarCampo = false

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      _idProyecto,
      __updatedField: 'precio',
      __focusCantidad,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  const actualizarPresupuestoHandler = infoPresupuesto => {
    let __focusCantidad = false
    let __focusPrecio = false
    let saltarFila = false
    let saltarCampo = false

    actualizarFilaHandler({
      ...row,
      ...infoPresupuesto,
      cantidad,
      precio,
      _idProyecto,
      __updatedField: 'precio',
      __focusCantidad,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  // Función para mostrar el detalle truncado
  const mostrarDetalleTruncado = () => {
    const textoDetalle = row.detalle || ''
    if (!textoDetalle) return null

    const textoCorto = textoDetalle.length > 80 ? `${textoDetalle.substring(0, 80)}...` : textoDetalle

    return textoCorto
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        if (inputCantidadRef.current) {
          inputCantidadRef.current.select()
        }
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td style={{ fontSize: '0.85em' }}>{row.correlativoRequerimiento || '--'}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>{row.nombreProducto || '--'}</td>
        <td
          style={{
            width: '350px',
            cursor: 'pointer',
            padding: '8px',
            backgroundColor: row.detalle ? '#f8f9fa' : 'transparent',
            borderRadius: '3px'
          }}
          onClick={() => abrirModalDetalle(row)}
          title='Click para editar detalle'
        >
          {row.detalle ? (
            <div
              style={{
                whiteSpace: 'pre-wrap',
                fontSize: '0.9em',
                lineHeight: '1.2',
                maxHeight: '60px',
                overflow: 'hidden'
              }}
            >
              {mostrarDetalleTruncado()}
            </div>
          ) : (
            <em style={{ color: '#999', fontSize: '0.85em' }}>Agregar detalle...</em>
          )}
        </td>
        <td>
          <Form.InputText
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => {
              const val = e.target.value
              // Bloquear negativos en captura
              if (val === '' || val === '-' ) {
                setCantidad('')
                return
              }
              const num = parseFloat(val)
              if (isNaN(num) || num < 0) {
                setCantidad('')
                return
              }
              setCantidad(val)
            }}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
          {esDeRequerimiento && row.cantidadOriginalRequerimiento != null && (
            <small
              style={{
                color: row.__cantidadClampada ? '#dc3545' : '#888',
                fontSize: '0.75em',
                fontWeight: row.__cantidadClampada ? 'bold' : 'normal'
              }}
            >
              {row.__cantidadClampada
                ? `Máx: ${row.cantidadOriginalRequerimiento}`
                : `Pend: ${row.cantidadPendiente} / Máx: ${row.cantidadOriginalRequerimiento}`}
            </small>
          )}
        </td>
        <td>{row.nombreUnidadDeMedida || '--'}</td>
        <td>
          <Form.InputText
            placeholder='0'
            value={precio}
            onChange={e => {
              const val = e.target.value
              if (val === '' || val === '-') {
                setPrecio('')
                return
              }
              const num = parseFloat(val)
              if (isNaN(num) || num < 0) {
                setPrecio('')
                return
              }
              setPrecio(val)
            }}
            onKeyUp={keyUpPrecioHandler}
            onKeyDown={keyDownPrecioHandler}
            onFocus={e => e.currentTarget.select()}
            autoFocus={row.__filaActiva && row.__focusPrecio}
          />
        </td>
        {__adminContext.valoresConfiguracionCompania.flagUsoPresupuesto && (
          <>
            <td>
              <ProyectoSelect
                id={`select-det-proyecto-${index}`}
                name={`select-det-proyecto-${index}`}
                value={_idProyecto}
                onChange={e => setIdProyecto(e.target.value)}
                onBlur={blurProyecto}
              />
            </td>
            <td align='center'>
              <span>{row.codigoPresupuestoInfo || '--'}</span>
              <Button onClick={() => setMostrarActualizarPresupuestoModal(true)}>o</Button>
            </td>
          </>
        )}
        <td>{parseFloat(row.subTotal || '0.00').toFixed(2)}</td>
        <td style={{ whiteSpace: 'nowrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <button
              type='button'
              onClick={clickEliminarFilaHandler}
              title='Quitar ítem'
              style={{
                border: 'none',
                background: 'transparent',
                color: '#dc3545',
                cursor: 'pointer',
                fontSize: '1.1em',
                padding: '2px 4px'
              }}
            >
              &times;
            </button>

            <Table.Dropdown>
              {({ handleClose }) => [
                <Table.Dropdown.Item
                  key='historial-compras'
                  handleClose={handleClose}
                  onClick={() => setMostrarModalHistorialCompras(true)}
                >
                  Ver Compras
                </Table.Dropdown.Item>,
                <Table.Dropdown.Item
                  key='comentario'
                  handleClose={handleClose}
                  onClick={clickActualizarComentarioHandler}
                >
                  Comentario
                </Table.Dropdown.Item>,
                <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                  Eliminar
                </Table.Dropdown.Item>
              ]}
            </Table.Dropdown>
          </div>
        </td>
      </tr>
      {mostrarActualizarComentarioModal && (
        <Modals.ActualizarComentarioModal
          handleClose={e => setMostrarActualizarComentarioModal(false)}
          show={mostrarActualizarComentarioModal}
          modalData={row}
          actualizarComentarioHandler={actualizarComentarioInnerHandler}
        />
      )}
      {mostrarModalHistorialCompras && (
        <Modals.HistorialComprasModal
          handleClose={e => setMostrarModalHistorialCompras(false)}
          show={mostrarModalHistorialCompras}
          idProductoPresentacion={row._id}
        />
      )}
      {mostrarActualizarPresupuestoModal && (
        <Modals.ActualizarPresupuestoNivel3Modal
          handleClose={e => setMostrarActualizarPresupuestoModal(false)}
          show={mostrarActualizarPresupuestoModal}
          modalData={row}
          actualizarPresupuestoHandler={actualizarPresupuestoHandler}
        />
      )}
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
